export enum StickerCreateStepEnum {
  SelectFormat = 'select_format',
  PhotoConfigure = 'photo_configure',
  VideoConfigure = 'video_configure',
  AudioConfigure = 'audio_configure',
  SelectTheme = 'select_theme',
  InputMessage = 'input_message',
  Preview = 'preview',
  Congratulations = 'congratulations'
}



// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/enums/StickerCreateStepEnum.ts